import Investigate from './investigate';
export default Investigate;
